import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INoteCreationDTO, INoteDTO } from '@app/infrastructure/models/note';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationService } from '../notification.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NotesService {
  private controllerRoute: string = 'students';
  private url: string = `${environment.apiRoute}`;

  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {
    this.url = `${environment.apiRoute}/${this.controllerRoute}`;
  }

  public createNote(payload: INoteCreationDTO): Observable<INoteDTO> {
    const endpoint = `${this.url}/${payload.studentId}/notes/`;

    return this.apiService
      .post<INoteDTO, INoteCreationDTO>(endpoint, payload)
      .pipe(
        tap(() => {
          const message = `Note created.`;
          return this.notificationService.showSuccess([message]);
        }),
      );
  }

  public updateNote(
    noteId: number,
    payload: INoteCreationDTO,
    showMessage = false,
  ): Observable<INoteDTO> {
    const endpoint = `${this.url}/${payload.studentId}/notes/${noteId}`;

    return this.apiService
      .patch<INoteDTO, INoteCreationDTO>(endpoint, payload)
      .pipe(
        tap(() => {
          if (showMessage) {
            const message = `Note updated.`;
            return this.notificationService.showSuccess([message]);
          }
        }),
      );
  }

  public fetchNotes(
    studentId: string,
    dayBlockId: number,
    classroomId: string = null,
  ): Observable<INoteDTO[]> {
    const endpoint = `${this.url}/${studentId}/notes/`;
    let params = new HttpParams();
    params = params.set('dayBlockId', dayBlockId);
    if (classroomId) {
      params = params.set('classroomId', classroomId);
    }

    return this.apiService.get<INoteDTO[]>(endpoint, {
      params,
    });
  }

  public deleteNote(studentId: string, noteId: number): Observable<INoteDTO> {
    const endpoint = `${this.url}/${studentId}/notes/${noteId}`;
    return this.apiService.delete<INoteDTO>(endpoint).pipe(
      tap(() => {
        const message = `Note deleted.`;
        return this.notificationService.showSuccess([message]);
      }),
    );
  }
}
